class GlobalMobileNavigation extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.loadElements();
    this.loadEventListeners();
  }

  expandableNavigationEventHandler(event) {
    const closeBtn = event.target.closest(".expandable-navigation-back");
    if (closeBtn) {
      const details = closeBtn.closest("details");
      details.removeAttribute("open");
      return;
    }
  }

  showSearchInput() {
    this.closeNavigation();
    document
      .querySelector("details-modal.header__search details")
      .setAttribute("open", true);
  }

  openNavigation() {
    this.body.classList.add("overflow-hidden-tablet");
    this.header.style.zIndex = 0;
    this.navigation.classList.add("open-global-mobile-navigation");
    if (this.chat) this.chat.style.display = "none";
    if (this.zonos) this.zonos.style.display = "none";
  }

  closeNavigation() {
    this.navigation.classList.remove("open-global-mobile-navigation");
    this.body.classList.remove("overflow-hidden-tablet");
    this.header.style.zIndex = 4;
    if (this.chat) this.chat.style.display = "block";
    if (this.zonos) this.zonos.style.display = "block";
  }

  loadElements() {
    this.navigation = this.querySelector(
      "#global-mobile-navigation--container"
    );
    this.expandableNavigation = this.querySelector(
      "#global-mobile-navigation--expandable-navigation"
    );
    this.openBtn = this.querySelector("#global-mobile-navigation--open");
    this.closeBtn = this.querySelector("#global-mobile-navigation--close");
    this.body = document.querySelector("body");
    this.header = document.querySelector(".shopify-section-group-header-group");
    this.searchButton = this.querySelector(
      "#global-mobile-navigation--search-link"
    );
    this.chat = document.querySelector(".shop-ai-chat-container");
    this.zonos = document.querySelector("#zonos-hello-widget");
  }

  loadEventListeners() {
    this.openBtn.addEventListener("click", this.openNavigation.bind(this));
    this.closeBtn.addEventListener("click", this.closeNavigation.bind(this));
    this.expandableNavigation.addEventListener(
      "click",
      this.expandableNavigationEventHandler.bind(this)
    );
    this.searchButton.addEventListener(
      "click",
      this.showSearchInput.bind(this)
    );
  }

  disconnectedCallback() {
    this.openBtn.removeEventListener("click", this.openNavigation.bind(this));
    this.closeBtn.removeEventListener("click", this.closeNavigation.bind(this));
  }
}
customElements.define("global-mobile-navigation", GlobalMobileNavigation);
